/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityGetInternal} from '../api'

export const useMutationActivityGetInternal = createReactQueryMutationHook('activityGetInternal', activityGetInternal)
